import React from "react";
import "./UserLayout.less";

const UserLayout = ({ children }) => {
  return <div className="user-layout">{children}</div>;
};

export default UserLayout;
